import { makeStyles } from "@mui/styles";
import { rem, goShare } from "assets/js/common";
import { useParams } from "react-router-dom";
import { useState } from "react";

const useStyles = makeStyles((theme) => ({
  share: {
    position: "fixed",
    display: "block",
    width: rem(50),
    height: rem(50),
    right: rem(25),
    bottom: rem(25),
  },
}));

export default function Share(props) {
  const classes = useStyles();
  const { seq } = useParams();
  const [shareable, setShareable] = useState(false);
  const checkShareable = () => {
    if (!shareable) {
      setShareable(true);
      goShare("event", seq);

      setTimeout(() => {
        setShareable(false);
      }, 1000);
    }
  };

  return (
    <div className={classes.share} onClick={checkShareable}>
      <img
        src={`${process.env.PUBLIC_URL}/images/icon/share.svg`}
        alt="공유하기"
      />
    </div>
  );
}
